
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "120px",
    "height": "121px",
    "viewBox": "0 -0.5 120 121",
    "enable-background": "new 0 -0.5 120 121",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "120",
        "height": "120"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFA84D",
        "d": "M12.431,89.436c0,4.558,3.728,8.287,8.284,8.287h73.736c4.558,0,8.287-3.729,8.287-8.287V36.135\r\n\tc0-4.557-3.729-8.287-8.287-8.287H20.715c-4.557,0-8.284,3.73-8.284,8.287V89.436z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#E6E6E6",
        "d": "M102.515,39.287c0.059-2.709-2.036-5.147-4.638-5.147H20.026c-2.601,0-4.763,2.438-4.821,5.147L14.232,84.91\r\n\tc-0.058,2.708,2.029,5.035,4.631,5.035h77.85c2.602,0,4.771-2.327,4.828-5.035L102.515,39.287z"
      }
    },
    {
      "tag": "radialGradient",
      "attrsMap": {
        "id": "SVGID_2_",
        "cx": "29.2656",
        "cy": "41.2617",
        "r": "67.8519",
        "gradientUnits": "userSpaceOnUse"
      },
      "children": [
        {
          "tag": "stop",
          "attrsMap": {
            "offset": "0",
            "style": "stop-color:#FDFDFD"
          }
        },
        {
          "tag": "stop",
          "attrsMap": {
            "offset": "0.3954",
            "style": "stop-color:#FAFAF9"
          }
        },
        {
          "tag": "stop",
          "attrsMap": {
            "offset": "0.7526",
            "style": "stop-color:#F0F0EE"
          }
        },
        {
          "tag": "stop",
          "attrsMap": {
            "offset": "1",
            "style": "stop-color:#E5E4E2"
          }
        }
      ]
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "url(#SVGID_2_)",
        "d": "M105.852,41.449c0.23-2.591-1.71-4.949-4.311-4.949H23.689c-2.601,0-4.917,2.358-5.146,4.949\r\n\tl-3.87,43.443c-0.23,2.591,1.71,4.607,4.311,4.607h77.851c2.601,0,4.917-2.017,5.147-4.607L105.852,41.449z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "#FFD17A",
        "d": "M60.928,53.234c4.558,0,8.768-2.73,9.355-6.065s4.799-6.066,9.355-6.066h24.797\r\n\tc4.558,0,7.805,2.731,7.217,6.066c-0.59,3.335-1.719,9.736-2.509,14.226l-4.967,28.167c-0.792,4.489-5.168,8.161-9.726,8.161H69.655\r\n\tc-4.557,0-12.015,0-16.572,0H20.715c-4.557,0-7.637-3.672-6.846-8.161l4.967-28.167c0.791-4.489,5.168-8.16,9.725-8.16H60.928z"
      }
    }
  ]
})
    }
  